export default __webpack_public_path__ + "static/media/transit-black.e1b99de7.svg";